import React from 'react';
import './POSTerminal.css';

const POSTerminal = () => {
  return (
    <div className="tablet-pos-stage">
      <div className="stage-lighting"></div>
      
      <div className="tablet-device">
        {/* Stand/Base */}
        <div className="tablet-stand">
          <div className="stand-platform">
            <div className="platform-surface"></div>
            <div className="platform-reflection"></div>
          </div>
          <div className="stand-column">
            <div className="column-face"></div>
            <div className="column-edge-left"></div>
            <div className="column-edge-right"></div>
          </div>
          <div className="stand-connector">
            <div className="connector-detail"></div>
          </div>
        </div>

        {/* Tablet Screen */}
        <div className="tablet-screen">
          {/* Outer Frame */}
          <div className="screen-frame">
            <div className="frame-edge-top"></div>
            <div className="frame-edge-bottom"></div>
            <div className="frame-edge-left"></div>
            <div className="frame-edge-right"></div>
            
            {/* Screen Bezel */}
            <div className="screen-bezel">
              <div className="bezel-inner"></div>
              
              {/* Display Panel */}
              <div className="display-panel">
                <div className="panel-glass">
                  
                  {/* Glass Effects */}
                  <div className="glass-reflection"></div>
                  <div className="glass-glare"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Environmental Effects */}
        <div className="device-shadow"></div>
      </div>
    </div>
  );
};

export default POSTerminal;